import { CONFIG } from '../config';
const baseUrl = CONFIG.API_BASE_URL;
//const baseUrl = 'http://localhost:5000';
export default baseUrl;
